import { format } from "date-fns";
import { RelativeDates } from "../date-picker-input.constants";
import { getRelativeDatesInfo } from "../date-picker-input.utilities";
import { IInitialPanelRange } from "./date-picker-panel.types";

/**
 * The range a panel opens on: the given range when there is one, otherwise the given preset's, otherwise the last 14
 * days. The calendar opens on the range's start month, and the times are the range's own.
 * @param startDate        The range's start, if any.
 * @param endDate          The range's end, if any.
 * @param relativeDateTime The preset, if any.
 * @returns The initial range, calendar month and times.
 */
export const getInitialPanelRange = (
    startDate: Date | undefined,
    endDate: Date | undefined,
    relativeDateTime: RelativeDates | undefined
): IInitialPanelRange => {
    const [start, end] =
        startDate && endDate
            ? [new Date(startDate), new Date(endDate)]
            : (() => {
                  const preset = getRelativeDatesInfo()[relativeDateTime ?? RelativeDates.Last14Days];
                  return [preset.startDate, preset.endDate];
              })();
    return {
        value: [start, end],
        calendarDate: start,
        startTime: format(start, "HH:mm"),
        endTime: format(end, "HH:mm"),
    };
};
